module.exports = __webpack_public_path__ + "static/media/youtube.2ac43334.svg";